import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  RemoveQtyFromCartBtnWrapperFnc,
  handleAddToCartWrapperFnc,
} from "../../utils/globalFunctions/cartFunctions";
import { defaultImage } from "../../utils/productUtils/ProductUtils";
import { ADD_TO_CART_ICON } from "../../utils/Constants";
import PrimaryButton from "../PrimaryButton";

const AddToCartComponent = ({
  checkProductQtyWithVariantStock,
  productItemObj,
  setSelectedProductEventHandler,
  setRelatedDiv,
  triggerQuickViewModal,
  id,
  productType,
  productImage,
  currentProduct,
  setCurrentProduct,
  cartItems,
}) => {
  const dispatch = useDispatch();

  // const [currentProduct, setCurrentProduct] = useState(null);
  const [isProductOutOfStock, setIsProductOutOfStock] = useState(false);
  useEffect(() => {
    // out of stock logic starts
    // console.log("productItemObj====>", productItemObj);
    if (productItemObj?.quantity <= 0) {
      setIsProductOutOfStock(true);
    }
    // out of stock logic ends
    // Filter the cart Item..
    // console.log("cartItems-=-=->",productItemObj);
    let filteredArray = [];
    if (cartItems && cartItems.length > 0) {
      if (productItemObj.havevariants === 1) {
        filteredArray = cartItems.filter(
          (x) => x.productid === productItemObj.productid
        );
      } else {
        filteredArray = cartItems.filter(
          (x) => x.productVarientId === productItemObj.productvarientid
        );
      }
      // Update the product Qty when product added to the cart...
      let filteredCartItems = [...filteredArray];

      // let totalQty = filteredCartItems.reduce(
      //   (acc, item) => acc + item.quantity,
      //   0
      // );
      let totalQty = filteredCartItems.find((x) => {
        return x.productVarientId === productItemObj.productvarientid;
      });

      if (filteredCartItems.length > 0) {
        let finalObj = filteredCartItems[0];
        const newObj = {
          ...finalObj,
          quantity: !!totalQty?.quantity ? totalQty?.quantity : 0,
          // quantity:totalQty
        };
        setCurrentProduct(newObj);
      } else {
        setCurrentProduct(null);
      }
    } else {
      setCurrentProduct(null);
    }
  }, [cartItems, productItemObj]);
  // console.log("==================start");
  // console.log("currentProduct", currentProduct);
  // console.log("--------------------End");
  return (
    <div className="buttonboxing">
      {!!isProductOutOfStock || (
        <div
          className={
            checkProductQtyWithVariantStock
              ? `buttons d-flex add-to-cart p-0`
              : `buttons px-sm-3 d-none add-to-cart p-0`
          }
        >
          <div
            className="productAddCartCounter col-sm-12"
            id={
              productType + `productAddCartCounter` + productItemObj.productid
            }
            style={{
              display: currentProduct?.quantity > 0 ? "inherit" : "none",
            }}
          >
            <i
              className="fas fa-minus minus minusButton buttons col-sm-3"
              onClick={() =>
                RemoveQtyFromCartBtnWrapperFnc(
                  productItemObj,
                  cartItems,
                  setSelectedProductEventHandler,
                  setRelatedDiv,
                  triggerQuickViewModal,
                  dispatch,
                  false
                )
              }
            ></i>
            <span className="cart-counter product_count text-center col-sm-6 fw-bolder">
              {currentProduct ? currentProduct.quantity : 0}
            </span>
            <i
              className="fas fa-plus plus plusButton buttons col-sm-3"
              onClick={() =>
                handleAddToCartWrapperFnc(
                  productItemObj,
                  cartItems,
                  setSelectedProductEventHandler,
                  setRelatedDiv,
                  triggerQuickViewModal,
                  id,
                  productType,
                  productImage,
                  defaultImage,
                  checkProductQtyWithVariantStock,
                  currentProduct,
                  dispatch,
                  false
                )
              }
            ></i>
          </div>
          <div>
            {(currentProduct?.quantity == 0 || currentProduct == null) && (
              <div className="col-sm-12 addCartButton_container">
                <PrimaryButton
                  id={productType + `addCartButton` + productItemObj.productid}
                  className=" btn cart-button btn-block w-100 px-3 py-0 addCartButton justify-content-center align-items-center"
                  name="Add"
                  type="button"
                  title={"Add to cart"}
                  onClick={() =>
                    handleAddToCartWrapperFnc(
                      productItemObj,
                      cartItems,
                      setSelectedProductEventHandler,
                      setRelatedDiv,
                      triggerQuickViewModal,
                      id,
                      productType,
                      productImage,
                      defaultImage,
                      checkProductQtyWithVariantStock,
                      currentProduct,
                      dispatch,
                      false
                    )
                  }
                  dataToggle={"modal"}
                  dataTarget={"#exampleTestingModal"}
                  ariaLabelledby={"#exampleTestingModal"}
                  // icon={ADD_TO_CART_ICON}
                />
              </div>
            )}
          </div>
        </div>
      )}
      {/* {(!checkProductQtyWithVariantStock || currentProduct?.quantity <= 0) && ( */}
      {isProductOutOfStock && (
        <div className="buttons d-flex add-to-cart p-0" style={{minHeight:"31px"}}>
          <h1 className="text-center text-danger m-0 fw-bold outofStockHeading d-flex justify-content-center align-items-center">
            Out Of Stock
          </h1>
        </div>
      )}
      {/* {!checkProductQtyWithVariantStock && (
        <div className={`buttons d-flex  add-to-cart p-0`}>
          <h1 className="text-center text-danger m-0 fw-bold outofStockHeading d-flex justify-content-center align-items-center">
            Out Of Stock
          </h1>
        </div>
      )}
      {currentProduct?.quantity <= 0 && (
        <div className={`buttons d-flex  add-to-cart p-0`}>
          <h1 className="text-center text-danger m-0 fw-bold outofStockHeading d-flex justify-content-center align-items-center">
            Out Of Stock
          </h1>
        </div>
      )} */}
    </div>
  );
};

export default AddToCartComponent;
